import { useState, useEffect } from "react";
import {
    Card,
    Grid,
    Tabs,
    Tab,
    Box,
    Typography,
    Fade,
    Button,
    useMediaQuery,
} from "@mui/material";
import MDAvatar from "components/MDAvatar";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
// Images
import burceMars from "assets/images/dummy-logo.png";

// TabPanel Component with Fade-in Animation
function TabPanel({ children, value, index }) {
    return (
        <Fade in={value === index} timeout={500}>
            <Box sx={{ p: 3, display: value === index ? "block" : "none" }}>{children}</Box>
        </Fade>
    );
}

export default function SubYojana() {
    const [value, setValue] = useState(0);
    const [yojna, setYojna] = useState([]);
    const [subYojna, setSubYojna] = useState([]);

    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width: 768px)");
    const yojna_department_id = useSelector((state) => state.yojnaId.yojnaId);

    useEffect(() => {
        const fetchYojnaDepartment = async () => {
            const access_token =
                localStorage.getItem("access_token") || sessionStorage.getItem("access_token");
            const user_role = localStorage.getItem("user_role") || sessionStorage.getItem("user_role");

            if (!access_token || !user_role) {
                console.error("❌ Access token or Role ID missing!");
                return;
            }

            try {
                const response = await axios.get(
                    `https://telelawmh.in/apiv2collectorapp/public/api/yojna/${yojna_department_id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${access_token}`,
                            "Content-Type": "application/json",
                            RoleID: user_role,
                        },
                    }
                );

                if (response.data.yojna.length > 0) {
                    setYojna(response.data.yojna);
                    setSubYojna(response.data.yojna[0].sub_yojnas || []);
                }
            } catch (error) {
                console.error("❌ API Error:", error.response ? error.response.data : error.message);
            }
        };

        fetchYojnaDepartment();
    }, [yojna_department_id]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSubYojna(yojna[newValue]?.sub_yojnas || []);
    };

    const handleSubYojanaClick = () => {
        navigate(`/static-table`);

    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box mt={5} mb={3}>
                <Card sx={{ p: 3 }}>
                    {/* Profile Section */}
                    <Grid container spacing={3} alignItems="center">
                        <Grid item>
                            <MDAvatar src={burceMars} alt="profile-image" size="xl" shadow="sm" />
                        </Grid>
                        <Grid item>
                            <MDTypography variant="h2" fontWeight="medium">
                                योजना
                            </MDTypography>
                        </Grid>
                    </Grid>

                    {/* Responsive Layout */}
                    <Box sx={{ mt: 3 }}>
                        <Grid container spacing={2}>
                            {/* Tabs Section - Left Sidebar */}
                            <Grid item xs={12} md={3}>
                                <Tabs
                                    orientation={isMobile ? "horizontal" : "vertical"}
                                    variant="scrollable"
                                    value={value}
                                    onChange={handleChange}
                                    sx={{
                                        borderRight: isMobile ? "none" : 1,
                                        borderBottom: isMobile ? 1 : "none",
                                        borderColor: "divider",
                                        p: 1,
                                        width: isMobile ? "100%" : "280px",
                                        "& .MuiTab-root": {
                                            minHeight: "50px",
                                            fontSize: "16px",
                                            fontWeight: "medium",
                                            textTransform: "none",
                                            color: "#374151",
                                            padding: "12px 20px",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            marginBottom: isMobile ? "0px" : "8px",
                                            transition: "all 0.3s ease-in-out",
                                            borderRadius: "0 !important", // ✅ Remove border radius completely
                                            "&:hover": {
                                                backgroundColor: "rgba(0, 136, 254, 0.1)",
                                                borderRadius: "0 !important", // ✅ Ensure no border radius on hover
                                            },
                                        },
                                        "& .Mui-selected": {
                                            background: "#0d47a1 !important",
                                            color: "#FFF !important",
                                            fontWeight: "bold",
                                            borderRadius: "0 !important", // ✅ Ensure no border radius for selected tab
                                        },
                                    }}
                                >
                                    {yojna.map((item, index) => (
                                        <Tab
                                            key={index}
                                            label={item.yojna_title}
                                            icon={<SubdirectoryArrowRightIcon />}
                                            iconPosition="start"
                                        />
                                    ))}
                                </Tabs>
                            </Grid>

                            {/* Sub-Yojana Section */}
                            <Grid item xs={12} md={9}>
                                <Box sx={{ flexGrow: 1, pl: 3 }}>
                                    {subYojna.length > 0 ? (
                                        <Grid container spacing={2}>
                                            {subYojna.map((item, index) => (
                                                <Grid item xs={12} sm={6} key={index}>
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        disableElevation
                                                        onClick={() => handleSubYojanaClick(item.id)}
                                                        sx={{
                                                            backgroundColor: "#0d47a1 !important", // ✅ New button color
                                                            color: "#FFF !important",
                                                            borderRadius: 0,
                                                            fontSize: "16px",
                                                            padding: "20px",
                                                            // marginRight: "px",
                                                            textTransform: "none",
                                                            textAlign: "left", // ✅ Text aligned to left
                                                            transition: "0.3s",
                                                            display: "-webkit-box",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: 1,
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            textOverflow: "ellipsis",
                                                            "&:hover": {
                                                                backgroundColor: "#1565c0 !important", // ✅ Hover color
                                                                transform: "scale(1.05)",
                                                            },
                                                        }}
                                                    >
                                                        <ArrowForwardIosIcon sx={{ mr: 1 }} />
                                                        {item.sub_yojna_title}
                                                    </Button>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    ) : (
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: "green", // Text color
                                                fontWeight: "bold", // Make text bold
                                                textAlign: "left", // Align text to the left
                                                p: 2,
                                                backgroundColor: "#868b931c", // Background color
                                            }}
                                        >
                                            कोणतीही उपयोजना उपलब्ध नाही
                                        </Typography>

                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Card>
            </Box>
        </DashboardLayout>
    );
}
